// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar {
	position: absolute;

	border-radius: 5px;
	text-transform: capitalize;
	background-color: var(--background-color-calendar);

	padding: 0.3rem;
}

.calendar__header {
	position: relative;
	border-radius: 5px 5px 0 0;
	background-color: var(--background-color-calendar-header);
	color: var(--ui-accent, #875b52);
	/* text small bold */
	font-family: ' Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 700;
	line-height: 160%; /* 1.6rem */
	padding: 10px;
	display: flex;
	justify-content: space-around;
	align-items: center;
}

.calendar__header__title {
	cursor: pointer;
}

.calendar__header__arrow__left {
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}

.calendar__header__arrow__right {
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transform: rotate(-180deg);
}

.calendar__body {
	border-radius: 0 0 5px 5px;
	padding: 5px;
}

.calendar__week__names {
	height: 20px;
	font-weight: 600;
	font-size: 8px;
	color: var(--color-additional);
	text-align: center;
	align-items: center;
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 1px 1px;
}

.calendar__days {
	font-size: 10px;
	font-weight: 400;
	color: var(--color-text);
	text-align: center;
	display: grid;
	text-align: center;
	align-items: center;
	grid-template-columns: repeat(7, 1fr);
	grid-template-rows: 1fr;
}

.calendar__day {
	padding: 5.5px 0px;
	cursor: pointer;
	width: 2.5rem;
	height: 2.5rem;
	border: 1px solid white;

	display: flex;
	align-items: center;
	justify-content: center;
}

.calendar__additional__day {
	padding: 5.5px;
	font-weight: 300;
	cursor: pointer;
	color: var(--color-placeholder);
}

.calendar__past__day {
	position: relative;
	color: var(--pink-color);
}

.calendar__past__day::after {
	content: ' ';
	position: absolute;
	width: 1rem;
	height: 1px;
	background-color: var(--pink-color);
}

.calendar__pick__item {
	padding: 9px 0px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	border-radius: 5px;
	border: 1px solid white;
	width: 5.8rem;
}

.calendar__pick__item:hover {
	border-radius: 10px;
	border: 1px solid var(--accent-color);
}

.calendar__today__item {
	border-radius: 10px;
	border-color: var(--accent-color);
}

.calendar__selected__item {
	color: var(--text-color);
	border-radius: 10px;
	background-color: var(--accent-color);
}
.calendar__selected__item:hover {
	border-radius: 10px;
	border: 1px solid var(--accent-color);
}

.calendar__pick__items__container {
	font-weight: 400;
	color: var(--color-text);
	text-align: center;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: repeat(4, 1fr);
	font-size: 12px;
	gap: 1rem;
}

.calendar__unchoosable__year {
	font-weight: 300;
	padding: 9px 16px;
	color: var(--color-placeholder);
	width: 5.8rem;
}

.calendar__day:hover {
	border-radius: 10px;
	background-color: var(--pink-color);
	color: var(--accent-color);
	border: 1px solid var(--pink-color);
}

.calendar__past__day:hover {
	background-color: white;
	cursor: not-allowed;
	border-color: white;
}

@media (max-width: 460px) {
	.calendar__pick__items__container {
		display: flex;
		justify-content: space-between;
		gap: 1rem;
		flex-wrap: wrap;
	}

	.calendar__header__title {
		font-size: 0.935rem;
	}

	.calendar__day {
		font-size: 0.935rem;
	}

	.calendar__day:hover {
		color: var(--text-color);
		border-radius: 10px;
		background-color: var(--accent-color);
	}

	.calendar__week_name {
		font-size: 0.935rem;
		width: 2.5rem;
		text-align: center;
	}

	.calendar__pick__item {
		font-size: 0.935rem;
	}

	.calendar__week__names {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 11px;
		margin: 0 6px;
	}
	.calendar__week_item {
		font-size: 0.935rem;
	}

	.calendar__additional__day {
		padding: 5.5px 0;
	}

	.calendar {
		border: 1px solid var(--accent-color, #875b52);
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/DatePicker/DatePicker.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;;CAElB,kBAAkB;CAClB,0BAA0B;CAC1B,kDAAkD;;CAElD,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B,yDAAyD;CACzD,gCAAgC;CAChC,oBAAoB;CACpB,yBAAyB;CACzB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;CAC9B,aAAa;CACb,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;CAC1B,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,cAAc;CACd,8BAA8B;CAC9B,kBAAkB;CAClB,mBAAmB;CACnB,aAAa;CACb,qCAAqC;CACrC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wBAAwB;CACxB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,mBAAmB;CACnB,qCAAqC;CACrC,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,aAAa;CACb,cAAc;CACd,uBAAuB;;CAEvB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,+BAA+B;AAChC;;AAEA;CACC,kBAAkB;CAClB,wBAAwB;AACzB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,mCAAmC;AACpC;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,uBAAuB;CACvB,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,qCAAqC;AACtC;;AAEA;CACC,mBAAmB;CACnB,iCAAiC;AAClC;;AAEA;CACC,wBAAwB;CACxB,mBAAmB;CACnB,qCAAqC;AACtC;AACA;CACC,mBAAmB;CACnB,qCAAqC;AACtC;;AAEA;CACC,gBAAgB;CAChB,wBAAwB;CACxB,kBAAkB;CAClB,aAAa;CACb,qCAAqC;CACrC,kCAAkC;CAClC,eAAe;CACf,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,+BAA+B;CAC/B,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,mCAAmC;CACnC,0BAA0B;CAC1B,mCAAmC;AACpC;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC;EACC,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;CAChB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;CACtC;;CAEA;EACC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;CACnB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,aAAa;CACd;CACA;EACC,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,8CAA8C;CAC/C;AACD","sourcesContent":[".calendar {\n\tposition: absolute;\n\n\tborder-radius: 5px;\n\ttext-transform: capitalize;\n\tbackground-color: var(--background-color-calendar);\n\n\tpadding: 0.3rem;\n}\n\n.calendar__header {\n\tposition: relative;\n\tborder-radius: 5px 5px 0 0;\n\tbackground-color: var(--background-color-calendar-header);\n\tcolor: var(--ui-accent, #875b52);\n\t/* text small bold */\n\tfont-family: ' Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 160%; /* 1.6rem */\n\tpadding: 10px;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n}\n\n.calendar__header__title {\n\tcursor: pointer;\n}\n\n.calendar__header__arrow__left {\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.calendar__header__arrow__right {\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttransform: rotate(-180deg);\n}\n\n.calendar__body {\n\tborder-radius: 0 0 5px 5px;\n\tpadding: 5px;\n}\n\n.calendar__week__names {\n\theight: 20px;\n\tfont-weight: 600;\n\tfont-size: 8px;\n\tcolor: var(--color-additional);\n\ttext-align: center;\n\talign-items: center;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(7, 1fr);\n\tgap: 1px 1px;\n}\n\n.calendar__days {\n\tfont-size: 10px;\n\tfont-weight: 400;\n\tcolor: var(--color-text);\n\ttext-align: center;\n\tdisplay: grid;\n\ttext-align: center;\n\talign-items: center;\n\tgrid-template-columns: repeat(7, 1fr);\n\tgrid-template-rows: 1fr;\n}\n\n.calendar__day {\n\tpadding: 5.5px 0px;\n\tcursor: pointer;\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tborder: 1px solid white;\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.calendar__additional__day {\n\tpadding: 5.5px;\n\tfont-weight: 300;\n\tcursor: pointer;\n\tcolor: var(--color-placeholder);\n}\n\n.calendar__past__day {\n\tposition: relative;\n\tcolor: var(--pink-color);\n}\n\n.calendar__past__day::after {\n\tcontent: ' ';\n\tposition: absolute;\n\twidth: 1rem;\n\theight: 1px;\n\tbackground-color: var(--pink-color);\n}\n\n.calendar__pick__item {\n\tpadding: 9px 0px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcursor: pointer;\n\tborder-radius: 5px;\n\tborder: 1px solid white;\n\twidth: 5.8rem;\n}\n\n.calendar__pick__item:hover {\n\tborder-radius: 10px;\n\tborder: 1px solid var(--accent-color);\n}\n\n.calendar__today__item {\n\tborder-radius: 10px;\n\tborder-color: var(--accent-color);\n}\n\n.calendar__selected__item {\n\tcolor: var(--text-color);\n\tborder-radius: 10px;\n\tbackground-color: var(--accent-color);\n}\n.calendar__selected__item:hover {\n\tborder-radius: 10px;\n\tborder: 1px solid var(--accent-color);\n}\n\n.calendar__pick__items__container {\n\tfont-weight: 400;\n\tcolor: var(--color-text);\n\ttext-align: center;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n\tgrid-template-rows: repeat(4, 1fr);\n\tfont-size: 12px;\n\tgap: 1rem;\n}\n\n.calendar__unchoosable__year {\n\tfont-weight: 300;\n\tpadding: 9px 16px;\n\tcolor: var(--color-placeholder);\n\twidth: 5.8rem;\n}\n\n.calendar__day:hover {\n\tborder-radius: 10px;\n\tbackground-color: var(--pink-color);\n\tcolor: var(--accent-color);\n\tborder: 1px solid var(--pink-color);\n}\n\n.calendar__past__day:hover {\n\tbackground-color: white;\n\tcursor: not-allowed;\n\tborder-color: white;\n}\n\n@media (max-width: 460px) {\n\t.calendar__pick__items__container {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tgap: 1rem;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.calendar__header__title {\n\t\tfont-size: 0.935rem;\n\t}\n\n\t.calendar__day {\n\t\tfont-size: 0.935rem;\n\t}\n\n\t.calendar__day:hover {\n\t\tcolor: var(--text-color);\n\t\tborder-radius: 10px;\n\t\tbackground-color: var(--accent-color);\n\t}\n\n\t.calendar__week_name {\n\t\tfont-size: 0.935rem;\n\t\twidth: 2.5rem;\n\t\ttext-align: center;\n\t}\n\n\t.calendar__pick__item {\n\t\tfont-size: 0.935rem;\n\t}\n\n\t.calendar__week__names {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tgap: 11px;\n\t\tmargin: 0 6px;\n\t}\n\t.calendar__week_item {\n\t\tfont-size: 0.935rem;\n\t}\n\n\t.calendar__additional__day {\n\t\tpadding: 5.5px 0;\n\t}\n\n\t.calendar {\n\t\tborder: 1px solid var(--accent-color, #875b52);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
